module.exports = __webpack_public_path__ + "static/media/Building.754fd526.jpg";